import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const GET_SHARED_MEDIA = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getSharedMedia',
    operationName: 'getSharedMedia',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
    ],
    fields: '{...SharedMediaResponseFields}',
    fragments: [Fragments.sharedMediaResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const LIST_SHARED_MEDIAS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'listSharedMedias',
    operationName: 'listSharedMedias',
    args: [
      { name: 'parent_type', type: 'String', required: true },
      { name: 'parent_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'parent_type', value: 'parent_type' },
      { name: 'parent_id', value: 'parent_id' },
    ],
    fields: '{...SharedMediaListResponseFields}',
    fragments: [Fragments.sharedMediaListResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const GET_SHARED_MEDIA_FILE = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getSharedMediaFile',
    operationName: 'GetSharedMediaFile',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
      { name: 'file_name', type: 'String' },
      { name: 'dl', type: 'String' },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
      { name: 'file_name', value: 'file_name' },
      { name: 'dl', value: 'dl' },
    ],
    fields: '{...SharedMediaFileResponseFields}',
    fragments: [Fragments.sharedMediaFileResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const GET_SHARED_MEDIA_PRESIGNED_URL = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getSharedMediaPresignedURL',
    operationName: 'getSharedMediaPresignedURL',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
      { name: 'intent', type: 'String' },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
      { name: 'intent', value: 'intent' },
    ],
    fields: '{...SharedMediaPresignedURLResponseFields}',
    fragments: [Fragments.sharedMediaPresignedURLResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const STREAM_SHARED_MEDIA_FILE = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'streamSharedMediaFile',
    operationName: 'streamSharedMediaFile',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
      { name: 'file_name', type: 'String', required: true },
      { name: 'dl', type: 'String' },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
      { name: 'file_name', value: 'file_name' },
      { name: 'dl', value: 'dl' },
    ],
    fields: '{...StreamSharedMediaFileResponseFields}',
    fragments: [Fragments.streamSharedMediaFileResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
